var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#6553F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.95 18.15H16.05V20.25H13.95V18.15ZM13.95 9.75H16.05V16.05H13.95V9.75ZM14.9895 4.5C9.1935 4.5 4.5 9.204 4.5 15C4.5 20.796 9.1935 25.5 14.9895 25.5C20.796 25.5 25.5 20.796 25.5 15C25.5 9.204 20.796 4.5 14.9895 4.5ZM15 23.4C10.359 23.4 6.6 19.641 6.6 15C6.6 10.359 10.359 6.6 15 6.6C19.641 6.6 23.4 10.359 23.4 15C23.4 19.641 19.641 23.4 15 23.4Z",
    fill: "#F7F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.2516fe73624eb191115ef7a89566276b.svg";
export { ForwardRef as ReactComponent };